"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCShim_1 = require("./adapter/VoxeetRTCShim");
const config_js_1 = require("../config/config.js");
const bowser_1 = __importDefault(require("bowser"));
/**
 * @ignore
 */
class AudioTagHelper {
    constructor(rtc, audio3D) {
        this.audio3D = audio3D;
        this.rtc = rtc;
        this.sinkId = null;
        this.playAudioPromise = null;
    }
    playAudioTag(peerId) {
        var node = document.getElementById('audio-' + peerId);
        node.play();
    }
    createAudioTag(peerId, stream) {
        if (stream && stream.getAudioTracks().length > 0) {
            var node = document.createElement('audio');
            node.setAttribute('id', 'audio-' + peerId);
            node.setAttribute('class', 'vxt-audio');
            document.body.appendChild(node);
            VoxeetRTCShim_1.attachMediaStream(node, stream);
            this.playAudioPromise = node.play();
            return this.playAudioPromise;
        }
        return Promise.resolve(true);
    }
    updateAudioTag(peerId, stream) {
        return __awaiter(this, void 0, void 0, function* () {
            if (stream && stream.getAudioTracks().length > 0) {
                var node = document.getElementById('audio-' + peerId);
                if (node) {
                    if (this.playAudioPromise) {
                        yield this.playAudioPromise;
                    }
                    VoxeetRTCShim_1.attachMediaStream(node, stream);
                    return node.play();
                }
                else {
                    return this.createAudioTag(peerId, stream);
                }
            }
            return Promise.resolve(true);
        });
    }
    removeAudioTag(peerId) {
        var node = document.getElementById('audio-' + peerId);
        if (node) {
            node.parentNode.removeChild(node);
        }
    }
    setAudioTagVolume(peerId, x, y) {
        var node = document.getElementById('audio-' + peerId);
        if (node && bowser_1.default.chrome && this.audio3D) {
            //Only for chrome to activate echo canceller
            let cutOffVolume = config_js_1.audioSettings.chromeCutOffVolume;
            const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
            const lambda = 4;
            cutOffVolume = cutOffVolume * Math.exp(-lambda * distance);
            if (cutOffVolume < 0.001 || !isFinite(cutOffVolume)) {
                cutOffVolume = 0.001;
            }
            node.volume = cutOffVolume;
        }
    }
    isMuted(peerId) {
        var node = document.getElementById('audio-' + peerId);
        if (node) {
            return node.volume === 0.0;
        }
        return false;
    }
    muteAudioTag(peerId, isMuted) {
        var node = document.getElementById('audio-' + peerId);
        if (node) {
            if (isMuted) {
                node.volume = 0.0;
            }
            else {
                if (this.audio3D) {
                    let position = this.rtc.getPeerPosition(peerId);
                    this.setAudioTagVolume(peerId, position.x, position.y);
                }
                else {
                    node.volume = 1.0;
                }
            }
        }
    }
    toggleMute(userId) {
        const isMuted = this.isMuted(userId);
        this.muteAudioTag(userId, !isMuted);
        return !isMuted;
    }
    setSinkId(deviceId) {
        this.sinkId = deviceId;
        this.updateSinks();
    }
    updateSinks() {
        const matches = document.querySelectorAll('.vxt-audio');
        matches.forEach((v) => {
            v.setSinkId(this.sinkId).catch((e) => console.error(e));
        });
    }
}
exports.default = AudioTagHelper;
